import { makeHttpRequest } from "@/shared";

import { mapRentToCancelToServer } from "./mappers/mapRentsToCancelToServer";

export const reopenRent = async (sessionKey, rent) => {
    const response = (
        await makeHttpRequest({
            url: "/rent/reopen",
            method: "POST",
            data: {
                session_key: sessionKey,
                ...mapRentToCancelToServer(rent),
            },
        })
    ).data;

    return response;
};
